import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { PlayerSearchDialogComponent } from 'src/app/player-search-dialog/player-search-dialog.component';
import { PlayerViewModel } from '../../models/player.model';
import { PlayerService } from '../../player.service';
import { TeamService } from '../../team.service';
import { TeamModel, TeamViewModel } from 'src/app/scouting/models/TeamModels';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatSelectionList, MatListOption } from '@angular/material/list';

import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-select-single-team-dialog',
    templateUrl: './select-single-team-dialog.component.html',
    styleUrls: ['./select-single-team-dialog.component.css'],
    imports: [MatDialogTitle, ReactiveFormsModule, CdkScrollable, MatDialogContent, MatSelectionList, FormsModule, MatListOption, MatDialogActions, MatButton, MatDialogClose]
})
export class SelectSingleTeamDialogComponent implements OnInit {

  @Output() dataChanged =  new EventEmitter();
  @Input() Action: string;

  teamsForm: UntypedFormGroup;
  _teams: TeamModel[];
  isLoading = false;

  selectedTeam: string;

  constructor(private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<SelectSingleTeamDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _teamService: TeamService
  ) { }

 

  ngOnInit() {
    this._teamService.getUserTeams().subscribe(data=>{
      
      this._teams = data as TeamModel[];
    });
    

  }


  


}
